<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Transaction ID Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.transaction_id')"
                v-model.trim="filterOptions.transaction_id"
              />
              <!-- End:: Transaction ID Input -->

              <!-- Start:: Transaction Type Input -->
              <base-select-input
                col="4"
                :optionsList="transactionTypes"
                :placeholder="$t('PLACEHOLDERS.transaction_type')"
                v-model="filterOptions.transaction_type"
              />
              <!-- End:: Transaction Type Input -->

              <!-- Start:: Date From Input -->
              <base-picker-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.from_date')"
                v-model="filterOptions.from_date"
              />
              <!-- End:: Date From Input -->

              <!-- Start:: Date To Input -->
              <base-picker-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.to_date')"
                v-model="filterOptions.to_date"
              />
              <!-- End:: Date To Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("SIDENAV.wallet_transactions") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
        <div class="table_buttons_wrapper">
          <button class="button_style_1" @click="chargeWallet">
            <i class="fal fa-plus"></i>
            {{ $t("BUTTONS.charge_wallet") }}
          </button>
          <button
            class="button_style_2"
            @click="openWithdrawalRequestModal"
            :disabled="hasPendingWithdrawal"
          >
            <i class="fal fa-money-check-alt"></i>
            {{ $t("BUTTONS.withdrawal_request") }}
          </button>
          <button
            class="button_style_3"
            @click="$router.push('/wallet/withdrawal-requests')"
          >
            <i class="fal fa-list"></i>
            {{ $t("BUTTONS.withdrawal_requests_log") }}
          </button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Wallet Balance Section =========== -->
      <div class="wallet_balance_wrapper">
        <div class="balance_card">
          <div class="balance_icon">
            <i class="fal fa-wallet"></i>
          </div>
          <div class="balance_info">
            <h6>{{ $t("PLACEHOLDERS.wallet_balance") }}</h6>
            <h3>{{ walletBalance }} {{ $t("PLACEHOLDERS.riyal") }}</h3>
          </div>
        </div>
        <div class="balance_card">
          <div class="balance_icon">
            <i class="fal fa-exchange-alt"></i>
          </div>
          <div class="balance_info">
            <h6>{{ $t("PLACEHOLDERS.total_transactions") }}</h6>
            <h3>{{ tranasactions_count }}</h3>
          </div>
        </div>
      </div>
      <!--  =========== End:: Wallet Balance Section =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <template v-slot:[`item.date_time`]="{ item }">
          <div v-if="item.date_time">
            <p>{{ item.date }}</p>
            <p class="text-muted">{{ item.time }}</p>
          </div>
          <p v-else>-</p>
        </template>

        <template v-slot:[`item.steps`]="{ item }">
          <span
            :class="
              item.transaction_type === 'deposit'
                ? 'text-success'
                : 'text-danger'
            "
          >
            {{ item.transaction_type === "deposit" ? "+" : ""
            }}{{ item.steps }} {{ $t("PLACEHOLDERS.riyal") }}
          </span>
        </template>

        <template v-slot:[`item.transaction_type`]="{ item }">
          <span v-if="item.name === 'wallet_charge'">
            {{ $t("PLACEHOLDERS.wallet_charge") }}
          </span>
          <span v-else-if="item.name === 'pay_chat'">
            {{ $t("PLACEHOLDERS.pay_chat") }}
          </span>
          <span v-else-if="item.name === 'accept_request'">
            {{ $t("PLACEHOLDERS.accept_request") }}
          </span>
          <span v-else>{{ item.name }}</span>
        </template>

        <template v-slot:[`item.serial_number`]="{ item, index }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id">-</p>
          <p v-else>
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </p>
        </template>

        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- End:: No Data State -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->

    <!-- Start:: Withdrawal Request Modal -->
    <v-dialog v-model="withdrawalRequestModal" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("PLACEHOLDERS.withdrawal_request") }}
        </v-card-title>
        <v-card-text>
          <div class="w-100 px-4 single_step_form_content_wrapper">
            <form @submit.prevent="submitWithdrawalRequest">
              <div class="row">
                <!-- Bank Name -->
                <base-input
                  col="12"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.bank_name')"
                  v-model.trim="withdrawalForm.bank_name"
                  required
                />

                <!-- IBAN Number -->
                <base-input
                  col="12"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.iban_number')"
                  v-model.trim="withdrawalForm.iban"
                  required
                />

                <!-- Amount -->
                <base-input
                  col="12"
                  type="number"
                  :placeholder="$t('PLACEHOLDERS.withdrawal_amount')"
                  v-model.number="withdrawalForm.steps"
                  required
                  min="1"
                  :max="walletBalance"
                />

                <div class="col-12">
                  <p class="text-muted">
                    {{ $t("PLACEHOLDERS.available_balance") }}:
                    {{ walletBalance }} {{ $t("PLACEHOLDERS.riyal") }}
                  </p>
                </div>
              </div>

              <div class="text-center mt-5">
                <v-btn
                  class="modal_confirm_btn mx-1 bg-success text-white"
                  type="submit"
                  :disabled="isSubmittingWithdrawal"
                >
                  {{ $t("BUTTONS.submit") }}
                </v-btn>
                <v-btn
                  class="modal_confirm_btn mx-1 bg-secondary text-white"
                  @click="closeWithdrawalRequestModal"
                  :disabled="isSubmittingWithdrawal"
                >
                  {{ $t("BUTTONS.cancel") }}
                </v-btn>
              </div>
            </form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End:: Withdrawal Request Modal -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WalletTransactions",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    transactionTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.wallet_charge"),
          value: "wallet_charge",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.pay_chat"),
          value: "pay_chat",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.accept_request"),
          value: "accept_request",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      isSubmittingWithdrawal: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        transaction_id: null,
        transaction_type: null,
        from_date: null,
        to_date: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "serial_number",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.transaction_id"),
          value: "id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.transaction_type"),
          value: "transaction_type",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.amount"),
          value: "steps",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.transaction_date"),
          value: "date_time",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Wallet Data
      walletBalance: 0,
      totalTransactions: 0,
      tranasactions_count: 0,
      hasPendingWithdrawal: false,
      // End:: Wallet Data

      // Start:: Withdrawal Request Modal
      withdrawalRequestModal: false,
      withdrawalForm: {
        bank_name: "",
        iban: "",
        steps: null,
      },
      // End:: Withdrawal Request Modal

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10000,
      },
      // End:: Pagination Data
    };
  },

  watch: {
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
  },

  methods: {
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/wallet/transactions",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },

    async resetFilter() {
      this.filterOptions.transaction_id = null;
      this.filterOptions.transaction_type = null;
      this.filterOptions.from_date = null;
      this.filterOptions.to_date = null;

      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/wallet/transactions",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "wallet-transactions",
          params: {
            page: this.paginations.current_page,
            id: this.filterOptions.transaction_id,
            name: this.filterOptions.transaction_type?.value,
            from: this.filterOptions.from_date,
            to: this.filterOptions.to_date,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data.data || [];

        // Update pagination data
        this.paginations.current_page = res.data.data.meta.current_page;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;

        // Calculate wallet balance and total transactions
        this.calculateWalletInfo();
      } catch (error) {
        this.loading = false;
        console.log(error.response?.data?.message || error.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.someErrorOccurred")
        );
      }
    },

    // Calculate wallet balance
    calculateWalletInfo() {
      this.totalTransactions = this.tableRows.length;

      // Get wallet balance from API or calculate it
      this.getWalletBalance();
    },

    async getWalletBalance() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "wallet-balance",
        });
        this.walletBalance = parseFloat(
          res.data.data.data.current_balance || 0
        );
        this.tranasactions_count = parseFloat(
          res.data.data.data.tranasactions_count || 0
        );
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },

    // Start:: Charge Wallet
    chargeWallet() {
      // Redirect to payment gateway or open payment modal
      this.$router.push("/wallet/charge");
    },
    // End:: Charge Wallet

    // Start:: Withdrawal Request
    openWithdrawalRequestModal() {
      this.withdrawalRequestModal = true;
    },

    closeWithdrawalRequestModal() {
      this.withdrawalRequestModal = false;
      this.withdrawalForm = {
        bank_name: "",
        iban: "",
        steps: null,
      };
    },

    async submitWithdrawalRequest() {
      // Validation
      if (
        !this.withdrawalForm.bank_name ||
        !this.withdrawalForm.iban ||
        !this.withdrawalForm.steps
      ) {
        this.$message.error(this.$t("MESSAGES.fillAllFields"));
        return;
      }

      if (this.withdrawalForm.steps > this.walletBalance) {
        this.$message.error(this.$t("MESSAGES.insufficient_balance"));
        return;
      }

      this.isSubmittingWithdrawal = true;

      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("bank_name", this.withdrawalForm.bank_name);
      REQUEST_DATA.append("iban", this.withdrawalForm.iban);
      REQUEST_DATA.append("steps", this.withdrawalForm.steps);

      try {
        await this.$axios({
          method: "POST",
          url: "wallet-withdrawal-request",
          data: REQUEST_DATA,
        });

        this.isSubmittingWithdrawal = false;
        this.closeWithdrawalRequestModal();
        this.$message.success(this.$t("MESSAGES.withdrawal_request_sent"));

        // Refresh data
        this.setTableRows();
      } catch (error) {
        this.isSubmittingWithdrawal = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.someErrorOccurred")
        );
      }
    },
    // End:: Withdrawal Request
  },

  created() {
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });

    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }

    this.setTableRows();
    this.getWalletBalance();
  },
};
</script>

<style scoped lang="scss">
.wallet_balance_wrapper {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;

  .balance_card {
    flex: 1;
    min-width: 250px;
    background: #1b706f;
    border-radius: 15px;
    padding: 25px;
    display: flex;
    align-items: center;
    gap: 20px;
    color: white;
    box-shadow: 0 4px 15px #1b706f;

    .balance_icon {
      font-size: 48px;
      opacity: 0.9;
    }

    .balance_info {
      h6 {
        margin: 0;
        font-size: 14px;
        opacity: 0.9;
        font-weight: 500;
      }

      h3 {
        margin: 5px 0 0 0;
        font-size: 32px;
        font-weight: 700;
      }
    }
  }
}

.table_buttons_wrapper {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  button {
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    gap: 8px;

    &.button_style_1 {
      background: #1b706f;
      color: white;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px #1b706f;
      }
    }

    &.button_style_2 {
      background: #1b706f;
      color: white;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px #1b706f;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
      }
    }

    &.button_style_3 {
      background: #1b706f;
      color: white;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px #1b706f;
      }
    }
  }
}

.text-success {
  color: #28a745;
  font-weight: 600;
}

.text-danger {
  color: #dc3545;
  font-weight: 600;
}
</style>
